window.addEventListener("load", function() {
    if ("IntersectionObserver" in window) {
        const lazyloadBg = document.querySelectorAll(".lazyBg");
        let navBgObserver = new IntersectionObserver(function(entries) {
            entries.forEach(function(entry) {
                if (entry.isIntersecting) {
                    let bgImage = entry.target;
                    bgImage.classList.remove("lazyBg");
                    navBgObserver.unobserve(bgImage);
                }
            });
        });
        lazyloadBg.forEach(function(bgImage) {
            navBgObserver.observe(bgImage);
        });
    }
});
